
import Vue from 'vue';
import URLS from '~/URLS';

// Components
import Button from '~/components/builders/Base/Button.vue';
import IconBtn from '../builders/IconBtn.vue';

// Assets
import vFairBankingFinanceConsultingPng from '~/assets/img/veventpromotion.png';

// Constants
const vFairIDBankingFinanceConsulting = '0792049e-5f8b-40ba-a943-d2f6ed83d5f3';

const vFairScreens: Record<string, string> = {
    [vFairIDBankingFinanceConsulting]: vFairBankingFinanceConsultingPng,
};

export default Vue.extend({
    name: 'VirtualEventPromotionDialog',
    components: {
        Button,
        IconBtn,
    },
    props: {
        vFairId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            screens: vFairScreens,
        };
    },
    computed: {
        screen(): string {
            if (this.screens[this.vFairId] === undefined) {
                return '';
            }
            return this.screens[this.vFairId];
        },
    },
    methods: {
        handleOnRegister() {
            // Go to register page
            this.$router.push(URLS.vfairs.concat('/', this.vFairId));
            this.handleOnClose();
        },
        handleOnClose() {
            // Close dialog
            this.$emit('close');
        },
    },
});
